<!-- layout.component.html -->
<div class="w-full h-full">
  <app-navbar></app-navbar>

  <main class="content">
    <ng-content></ng-content>
  </main>
  <app-footer></app-footer>
</div>
